import { EurekaDraft } from '../@Types/Draft/Draft';
import { RootApi } from '../Utils/_api';
import axiosInstance from '../Utils/AxiosAPI';
import widgetInstance from '../Utils/AxiosWidget';
import { AppState } from '../Utils/store';

export const DraftApi = RootApi.injectEndpoints({
    endpoints: (build) => ({
        mapDraft: build.query<
            EurekaDraft | undefined,
            {
                idForm: string;
                property: string;
                dependencies: Record<string, any>;
                mapDraftEntities?: (
                    property: string,
                    dependencies: Record<string, any>
                ) => Promise<EurekaDraft>;
            }
        >({
            queryFn: async (
                { idForm, dependencies, property, mapDraftEntities },
                { getState }
            ) => {
                const idOrganization = (getState() as AppState).forms[idForm]
                    .global.idOrganization;
                if (mapDraftEntities)
                    return {
                        data: await mapDraftEntities(property, dependencies),
                    };

                const apiKey = (getState() as AppState).forms[idForm].global
                    .apiKey;
                if (!apiKey) return { data: undefined };

                let response;
                if (idOrganization) {
                    response = await widgetInstance.post<EurekaDraft>(
                        `/form/draft/${apiKey}?idOrganization=${idOrganization}`,
                        {
                            property,
                            dependencies,
                        }
                    );
                } else {
                    response = await axiosInstance.post<EurekaDraft>(
                        `/form/draft/${apiKey}`,
                        dependencies
                    );
                }
                return { data: response.data };
            },
        }),
    }),
});
